import Cookies from 'js-cookie'
import { isObject } from "./index"
import md5 from 'js-md5';
const TIME = 'Time'
const EXP = 1000 * 60
import { getChannelInfo } from '../api/base'

export function isJZJX () {
  return /JZJX_Android/.test(navigator.userAgent)
}

export function getSign(info, secretKey = 'RrA3N3Qytd7mV8nQ6kxIWo2NSRMf5TSF') {
  const isProduction = !window.location.host.includes('test');
  if (!isProduction) {
    secretKey = 'zbwe7U8lVhDVgXSI2uSFjPOT7XPNm19K'
  }
  const sortedKeys = Object.keys(info).sort();
  const pairs = [];
  for (let i = 0; i < sortedKeys.length; i++) {
    const key = sortedKeys[i];
    pairs.push(`${key}=${info[key]}`);
  }
  let str = pairs.join('&');
  str += `${secretKey}`;
  console.log('str', str);
  console.log('md5', md5(str).toLowerCase());
  return md5(str).toLowerCase();
}

export const getLogo = async accountId => {
  document.title = '智适应教育-归一化课程'
  const logo = JSON.parse(sessionStorage.getItem(`${accountId}-ChangeLogoUrl`)) || {};
  if (logo.logoUrl) {
    return JSON.parse(sessionStorage.getItem(`${accountId}-ChangeLogoUrl`));
  }
  const params = {
    account_id: accountId
  };
  params.timestamp = getStamp();
  params.rand = getRandom(6);
  params.sign = getSign(params);
  const res = await getChannelInfo(params);
  const groundUrl = res.data.result.content.logo[0].url
  const NoGroundUrl = res.data.result.content.logo[1].url
  const logoUrl = {
    logoUrl: NoGroundUrl,
    groundUr: groundUrl,
  }
  sessionStorage.setItem(`${accountId}-ChangeLogoUrl`, JSON.stringify(logoUrl))
  return logo
}

export function getStamp () {
  const timeStamp = Date.parse(new Date()) / 1000
  // console.log(timeStamp);
  return timeStamp
}

export function getRandom (num) {
  var random = Math.floor((Math.random() + Math.floor(Math.random() * 9 + 1)) * Math.pow(10, num - 1))
  return random
}

// export function getUserCookieData() {
//   const str = Cookies.get('lms_user_info') || "{}"
//   return JSON.parse(str)
// }
export function setUserLocalData(obj) {
  if(isObject(obj)){
    let str = ''

    try {
      str = JSON.stringify(obj)
    }catch (e) {
      console.log('用户信息格式错误')
    }

    localStorage.setItem('lms_user_info', str)
  }else{
    console.log('用户信息格式错误')
  }
}

export function getUserLocalData() {
  let str = localStorage.getItem('lms_user_info') || "{}"
  let obj = JSON.parse(str)
  return obj
}

export function setTime(timeData) {
  if(!isObject(timeData)) return
  const oldValue = sessionStorage.getItem(TIME) || "[]"
  let oldValueArr = JSON.parse(oldValue)
  const timestap = new Date().getTime()

  const expFilter = oldValueArr.filter(item => timestap - item.time < EXP)
  oldValueArr = expFilter

  const res = oldValueArr.find(item => item.key === timeData.key)

  if(res){
    for(let i = 0, l = oldValueArr.length; i < l; i++){
      if(oldValueArr[i].key === timeData.key){
        oldValueArr[i].value = timeData.value
        oldValueArr[i].time = timestap
        break
      }
    }
  }else{
    timeData.time = timestap
    oldValueArr.push(timeData)
  }

  const newValueJSON = JSON.stringify(oldValueArr)

  sessionStorage.setItem(TIME, newValueJSON)
}

export function getTime(key) {
  const timestap = new Date().getTime()
  const str = sessionStorage.getItem(TIME) || "[]"
  const arr = JSON.parse(str)

  const resFilter = arr.find(item => item.key === key)
  let res = 0

  if(resFilter){
    if(timestap - resFilter.time < EXP){
      res = resFilter.value
    }
  }
  return res
}

export function initSocketMsgData(data) {
  let localData = getUserLocalData()
  let baseData = {
    role: 'STUDENT',
    user_id: parseInt(localData.user_id),
    subject_id: parseInt(localData.subject_id),
    school_id: parseInt(localData.school_id),
    course_id: parseInt(localData.course_id),
    // lesson_id: parseInt(localData.lessonId),
    // topic_id: parseInt(localData.topicId),
    // flow_id: parseInt(localData.flowId),
    stage: parseInt(localData.stage),
    nick: localData.user_name,
    // app_type: parseInt(localData.appType),
    // client_ip: localData.clientIp,
    learning_version: 2 //（1=v1, 2=v2），只有接入学习系统v2的学科新加这个字
  }
  let msg = Object.assign({}, baseData, data)
  return msg
}


// WEBPACK FOOTER //
// ./src/utils/auth.js